import { Routes } from '@angular/router';
import { Landing } from './pages/landing/landing';
import { AppsHealthcareMarketing } from './pages/apps-healthcare-marketing/apps-healthcare-marketing';
import { Blog } from './pages/blog/blog';
import { BlogPost } from './pages/blog-post/blog-post';
import { CaseStudies } from './pages/case-studies/case-studies';
import { InfluencerProcess } from './pages/influencer-process/influencer-process';
import { MarketingServices } from './pages/marketing-services/marketing-services';
import { PrivacyPolicy } from './pages/privacy-policy/privacy-policy';
import { AppDevelopmentCompany } from './pages/app-development-company/app-development-company';
import { WebsiteMarketingServices } from './pages/website-marketing-services/website-marketing-services';
import { DevelopmentCaseStudies } from './pages/development-case-studies/development-case-studies';
import { Team } from './pages/team/team';
import { ThankYou } from './pages/thank-you/thank-you';
import { CaseStudiesDetail } from './pages/case-studies-detail/case-studies-detail';
import { BusinessMobileConsultingComponent } from './pages/business-mobile-consulting/business-mobile-consulting.component';
import { AeoMarketingService } from './pages/aeo-marketing-service/aeo-marketing-service';
import { Archive } from './pages/archive/archive';
import { AiAutomation } from './pages/ai-automation/ai-automation';

export type TRoutes = 'development-case-studies' | 'marketing-case-studies' | 'blog' | 'privacy-policy' | 'app-development-company' | 'ai-app-development-company' | 'mobile-app-marketing-services' | 'influencer-process' | 'website-marketing-services' | 'apps-healthcare-marketing' | 'business-mobile-consulting' | 'aeo-marketing-services' | 'team' | 'thank-you-for-booking';

export const routes: Routes = [
    { path: 'development-case-studies', component: DevelopmentCaseStudies },
    { path: 'marketing-case-studies', component: CaseStudies },
    { path: 'blog', component: Blog },
    { path: 'team', component: Team },
    { path: 'privacy-policy', component: PrivacyPolicy },
    { path: 'app-development-company', component: AppDevelopmentCompany },
    // Both /app-development-company and /ai-app-development-company served as
    // separate pages in WordPress; their content was merged into a single
    // AppDevelopmentCompany page during the Angular migration. Per WP-URL
    // parity, both slugs render the same merged content.
    { path: 'ai-app-development-company', component: AppDevelopmentCompany },
    { path: 'mobile-app-marketing-services', component: MarketingServices },
    // Old slug — 301-style redirect to the SEO-friendly URL.
    { path: 'marketing-services', redirectTo: 'mobile-app-marketing-services', pathMatch: 'full' },
    { path: 'influencer-process', component: InfluencerProcess },
    { path: 'website-marketing-services', component: WebsiteMarketingServices },
    { path: 'business-mobile-consulting', component: BusinessMobileConsultingComponent },
    { path: 'aeo-marketing-services', component: AeoMarketingService },
    { path: 'ai-automation-agency', component: AiAutomation },
    // Old shorter slug — 301-style redirect to the SEO-friendly URL.
    { path: 'aiautomation', redirectTo: 'ai-automation-agency', pathMatch: 'full' },
    { path: 'apps-healthcare-marketing', component: AppsHealthcareMarketing },
    { path: 'thank-you-for-booking', component: ThankYou },
    { path: 'case-studies/:project', component: CaseStudiesDetail },
    { path: 'marketing/:project', component: CaseStudiesDetail },

    // Yoast-parity archive routes — mirror WP's /category/, /tag/, /author/
    // listing URLs. Each prerenders enumerated from CATEGORY_SLUGS / TAG_SLUGS
    // / AUTHOR_SLUGS in app.routes.server.ts.
    { path: 'category/:slug', component: Archive, data: { type: 'category' } },
    { path: 'tag/:slug', component: Archive, data: { type: 'tag' } },
    { path: 'author/:slug', component: Archive, data: { type: 'author' } },

    // Top-level marketing case-study slugs — these URLs existed on the original
    // WordPress site (each was a /<slug>/ root-level page in WP). Renders the
    // same CaseStudiesDetail component, fed by the slug in route data.
    { path: 'ualett', component: CaseStudiesDetail, data: { slug: 'ualett', type: 'marketing' } },
    { path: 'resonante', component: CaseStudiesDetail, data: { slug: 'resonante', type: 'marketing' } },
    { path: 'cauldy', component: CaseStudiesDetail, data: { slug: 'cauldy', type: 'marketing' } },
    { path: 'foojan', component: CaseStudiesDetail, data: { slug: 'foojan', type: 'marketing' } },
    { path: 'happy-mob', component: CaseStudiesDetail, data: { slug: 'happy-mob', type: 'marketing' } },
    { path: 'hatched', component: CaseStudiesDetail, data: { slug: 'hatched', type: 'marketing' } },
    { path: 'kicksnap', component: CaseStudiesDetail, data: { slug: 'kicksnap', type: 'marketing' } },
    { path: 'tito', component: CaseStudiesDetail, data: { slug: 'tito', type: 'marketing' } },
    { path: 'winquik', component: CaseStudiesDetail, data: { slug: 'winquik', type: 'marketing' } },
    { path: 'fysh', component: CaseStudiesDetail, data: { slug: 'fysh', type: 'marketing' } },
    { path: 'ultimate-playlist', component: CaseStudiesDetail, data: { slug: 'ultimate-playlist', type: 'marketing' } },
    { path: 'ramp-assist-boating', component: CaseStudiesDetail, data: { slug: 'ramp-assist-boating', type: 'marketing' } },
    // Newer marketing projects added after the WP era — also exposed at top-level.
    // Retired case study — redirect the old URL to the listing.
    { path: 'gestureit', redirectTo: 'marketing-case-studies', pathMatch: 'full' },
    { path: 'pulse-briefing', component: CaseStudiesDetail, data: { slug: 'pulse-briefing', type: 'marketing' } },
    { path: 'tackOn', component: CaseStudiesDetail, data: { slug: 'tackOn', type: 'marketing' } },
    { path: 'meet-amore', component: CaseStudiesDetail, data: { slug: 'meet-amore', type: 'marketing' } },

    { path: '', component: Landing, pathMatch: 'full' },
    // Top-level slug catch — must be LAST so all the explicit routes above match first.
    // Resolves to the migrated WP blog posts. Unknown slugs render a "not found" state inside BlogPost.
    { path: ':slug', component: BlogPost },
];

